import { render, staticRenderFns } from "./card-widget.vue?vue&type=template&id=4ba7b0ef&scoped=true"
import script from "./card-widget.vue?vue&type=script&lang=js"
export * from "./card-widget.vue?vue&type=script&lang=js"
import style0 from "./card-widget.vue?vue&type=style&index=0&id=4ba7b0ef&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba7b0ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba7b0ef')) {
      api.createRecord('4ba7b0ef', component.options)
    } else {
      api.reload('4ba7b0ef', component.options)
    }
    module.hot.accept("./card-widget.vue?vue&type=template&id=4ba7b0ef&scoped=true", function () {
      api.rerender('4ba7b0ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/container-widget/card-widget.vue"
export default component.exports